import type { ExMarking, GasGroup, TemperatureClass } from './types';

/**
 * Reads the parts of an Ex marking string that the equipment check needs, e.g. "Ex db IIB T4 Gb" or
 * "II 2G Ex eb IIC T3 Gb". ATEX categories (1G/2G/3G) map to EPL Ga/Gb/Gc when no EPL is written.
 */
export function parseMarking(text: string): Partial<ExMarking> {
  const t = ` ${text.replace(/\s+/g, ' ')} `;
  const out: Partial<ExMarking> = {};
  const epl = t.match(/\b(G[abc])\b/);
  if (epl) out.epl = epl[1] as ExMarking['epl'];
  else {
    const cat = t.match(/\b([123])\s?G\b/);
    if (cat) out.epl = ({ '1': 'Ga', '2': 'Gb', '3': 'Gc' } as const)[cat[1] as '1' | '2' | '3'];
  }
  const group = t.match(/\bII([ABC])\b/) ?? t.match(/\bII\b(?!\s?\d)/);
  if (group) out.gasGroup = group[1] ? (`II${group[1]}` as GasGroup) : 'II';
  const tc = t.match(/\bT([1-6])\b/);
  if (tc) out.tClass = `T${tc[1]}` as TemperatureClass;
  const temp = t.match(/\bT?\s?(\d{2,3})\s?°\s?C\b/);
  if (temp && !tc) out.maxSurfaceTempC = Number(temp[1]);
  return out;
}
